import React, { Component } from 'react'

export default class closeBurger extends Component {
    render() {
        return (
           
<svg className={this.props.className} onClick={this.props.onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 6L6 18" stroke="white" strokeWidth="2" stroke-linecap="round" strokeLinejoin="round"/>
<path d="M6 6L18 18" stroke="white" strokeWidth="2" stroke-linecap="round" strokeLinejoin="round"/>
</svg>
        )
    }
}
